<!-- overdue.component.html -->

<div class="container-fluid">
    <h1 class="h3 mb-2 text-gray-800">Overdues With Fines</h1>
    <div class="card mb-4">
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-bordered" id="dataTabled" width="100%" cellspacing="0">
            <thead>
              <tr>
                <th>Due Date</th>
                <th>Patron</th>
                <th>Patron Library</th>
                <th>Title</th>
                <th>Shelving Location</th>
                <th>Barcode</th>
                <th>Call Number</th>
                <th>Price</th>
                <th>Non-public Note</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>05/06/2024</td>
                <td>Mr Aniket Pandit (2604)</td>
                <td>Centerville</td>
                <td>Journal of politics</td>
                <td></td>
                <td>171717</td>
                <td>P233</td>
                <td>0.00</td>
                <td></td>
              </tr>
              <!-- Add more rows here if needed -->
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

